import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./SalarieForm.css";

const API_URL = process.env.REACT_APP_API_URL || "";

const PrixOuvrageList = () => {
  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchCharges = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API_URL}/api/prix-ouvrage`);
      setCharges(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setError("Erreur lors du chargement");
      setCharges([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCharges();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette charge ?")) return;
    try {
      await axios.delete(`${API_URL}/api/prix-ouvrage/${id}`);
      fetchCharges();
    } catch (err) {
      setError("Erreur lors de la suppression");
    }
  };

  const calculateTotal = () => {
    return charges.reduce((total, charge) => total + Number(charge.prix_mois || 0), 0);
  };

  if (loading) return <div className="loading">Chargement...</div>;

  if (error) {
    return (
      <div className="charges-form-container">
        <div className="form-header">
          <h2>Charges fixes</h2>
          <Link to="/prix-ouvrage/add" className="btn btn-primary">
            Configuration
          </Link>
        </div>
        <div className="form-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="charges-form-container">
      <div className="form-header">
        <h2>Configuration Charges fixes</h2>
        <Link to="/prix-ouvrage/add" className="btn btn-primary">
          Modifier Configuration
        </Link>
      </div>
      
      {charges.length === 0 ? (
        <div className="no-charges">
          Aucune configuration trouvée. 
          <Link to="/prix-ouvrage/add" style={{ marginLeft: "10px" }}>
            Créer la configuration
          </Link>
        </div>
      ) : (
        <div className="charges-grid">
          <div className="charge-card">
            <div className="charge-header">
              <h4 className="charge-name">Configuration Charges fixes</h4>
              <div>
                <button
                  className="btn btn-edit"
                  onClick={() => navigate(`/prix-ouvrage/add`)}
                >
                  ✏️ Modifier
                </button>
              </div>
            </div>
            <div className="charge-budget">
              Total: {calculateTotal().toFixed(2)} €/mois
            </div>
            <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
              {charges.map((charge) => (
                <li key={charge.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <span>{charge.nom}: {Number(charge.prix_mois || 0).toFixed(2)} €/mois</span>
                  {!["Frais financiers", "Emprunt", "Frais comptable", "Loyer", "Frais généraux", "Charge sociale"].includes(charge.nom) && (
                    <button
                      className="btn btn-delete"
                      style={{ 
                        padding: "2px 6px", 
                        fontSize: "12px",
                        marginLeft: "10px"
                      }}
                      onClick={() => handleDelete(charge.id)}
                    >
                      🗑️
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrixOuvrageList;
